import { render, staticRenderFns } from "./_LivingDonation.vue?vue&type=template&id=56fabebe"
import script from "./_LivingDonation.vue?vue&type=script&lang=ts"
export * from "./_LivingDonation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports